import { useState } from "react";
import { clsx } from "clsx";
import { UnitItemContext } from "@/context/UnitItemContext";
import { UnitPromotions } from "@/components/units/unit/info/UnitPromotions";
import { UnitDimension } from "@/components/units/unit/info/UnitDimension";
import { UnitFeatures } from "@/components/units/unit/info/UnitFeatures";
import { UnitUrgency } from "@/components/units/unit/info/UnitUrgency";
import { UnitAction } from "@/components/units/unit/info/UnitAction";
import { UnitPrice } from "@/components/units/unit/info/UnitPrice";
import { UnitImage } from "@/components/units/unit/info/UnitImage";
import type { UnitGroup } from "@/types";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useUnitDataAttributes } from "@/hooks/useUnitDataAttributes";

interface UnitItemProps {
    unitGroup: UnitGroup;
    layout: "grid" | "row";
}

export const UnitItem = ({ unitGroup, layout = "row" }: UnitItemProps) => {
    const { representative_unit, rates, available } = unitGroup;
    const [selectedPromo, setSelectedPromo] = useState<number>(() => {
        if (rates.promo_rates.length === 1 || rates.promo_rates.length > 1) {
            return rates.promo_rates[0].id;
        } else {
            return 0;
        }
    });
    const dataAttributes = useUnitDataAttributes(unitGroup);

    const unitItemInfo = {
        unitGroup,
        selectedPromo,
        setSelectedPromo,
    };

    return (
        <UnitItemContext.Provider value={unitItemInfo}>
            <ErrorBoundary>
                <div
                    className={clsx("unit-item", "unit-item--" + layout)}
                    {...dataAttributes}
                >
                    <div className="unit-item__image">
                        <UnitImage
                            length={representative_unit.length}
                            width={representative_unit.width}
                        />
                    </div>
                    <div className="unit-item__dimension">
                        <UnitDimension unitGroup={unitGroup} />
                    </div>
                    <div className="unit-item__category">
                        {representative_unit.category?.name ?? ""}
                    </div>
                    <div className="unit-item__features">
                        <UnitFeatures features={representative_unit.features} />
                    </div>
                    <div className="unit-item__promotions">
                        <UnitPromotions promotions={rates.promo_rates} />
                    </div>
                    <div className="unit-item__urgency">
                        <UnitUrgency available={available} />
                    </div>
                    <div className="unit-item__price">
                        <UnitPrice rates={rates} />
                    </div>
                    <div className="unit-item__action">
                        <UnitAction />
                    </div>
                </div>
            </ErrorBoundary>
        </UnitItemContext.Provider>
    );
};
